import { PropsWithChildren } from 'react';
import { MedialinksContextProvider } from './MedialinksContext';
import { PinnedMaterialContextProvider } from './PinnedMaterialContext';
import { SelectionContextProvider } from './SelectionContext';
import { SharedMaterialsContextProvider } from './SharedMaterialsContext';
import { SlideSetsContextProvider } from './SlideSetsContext';
import { UserMaterialContextProvider } from './UserMaterialContext';

export default function TocDataProvider({ children }: PropsWithChildren) {
  return (
    <SharedMaterialsContextProvider>
      <MedialinksContextProvider>
        <UserMaterialContextProvider>
          <SlideSetsContextProvider>
            <SelectionContextProvider>
              <PinnedMaterialContextProvider>{children}</PinnedMaterialContextProvider>
            </SelectionContextProvider>
          </SlideSetsContextProvider>
        </UserMaterialContextProvider>
      </MedialinksContextProvider>
    </SharedMaterialsContextProvider>
  );
}
